import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "weChatMsgWindowContainer" }
const _hoisted_2 = { class: "weChatMsgWindowHeader" }
const _hoisted_3 = { class: "weChatMsgWindowHeader--name" }
const _hoisted_4 = { class: "weChatMsgCard" }
const _hoisted_5 = { class: "weChatMsgCard--header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "weChatMsgCard--date" }, null, -1)
const _hoisted_7 = { class: "weChatMsgCard--content" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "high-light" }
const _hoisted_11 = {
  key: 0,
  class: "wechatReverseClass"
}
const _hoisted_12 = {
  key: 1,
  class: "wechatReverseClass"
}

import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { ref, computed, watchEffect, onMounted } from "vue";
import { WeChatActions, WeChatGetters } from "@/store/modules/weChat";
import { WeChatMsg } from "@/store/modules/weChat/types";
import { More, User } from "@element-plus/icons-vue";
import { wechatStaticUrl } from "@/requests";
import ReverseElementScroll from "@/utils/scrollerHijack";




import { defineComponent } from "vue";

const __default__ = defineComponent({
    name: "WeChatSearchMsgWindow",
})

interface highlight {
    normal: string,
    light: string,
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    isGetMsgByTarget: {
        type: Number,
        required: true,
    }
},
  setup(__props) {

const props = __props;



const route = useRoute();
const store = useStore();
const weChatMsgContainer = ref<HTMLElement | null>(null);

const wechatMsgListRef = ref<HTMLElement | null>(null);
onMounted(() => {
    const msgListElement = wechatMsgListRef.value; // 获取元素的引用

    if (msgListElement) {
        ReverseElementScroll(msgListElement)
    }
})

const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const wechatIdCom = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getMeId}`];
});

const isMsgLoading = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getIsMsgListLoading}`];
});

const selectedSession = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getSelectedSession}`];
});

const msgGroup = computed(() => {
    if (selectedSession.value !== null) {
        return store.getters[`weChat/${WeChatGetters.getSearchMsgListMap}`](selectedSession.value.strUsrName);
    } else {
        return [];
    }
});

const headerName = computed(() => {
    if (searchType.value === '用户') {
        return selectedSession.value ? selectedSession.value.NickName : "";
    } else {
        return selectedSession.value ? selectedSession.value.strUsrName : "";
    }
});

const isCurrentMsgListAllLoaded = computed(() => {
    if (selectedSession.value !== null) {
        return store.getters[`weChat/${WeChatGetters.getIsSearchMsgListAllLoadedByConvId}`](selectedSession.value.strUsrName);
    } else {
        return false;
    }
});

const shouldUpdate = computed(() => {
    return (!isCurrentMsgListAllLoaded.value && !isMsgLoading.value && selectedSession.value !== null);
});

const searchType = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getSearchType}`];
});
const searchTarget = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getSearchTarget}`];
});



const handleScroll = () => {
    if (wechatMsgListRef.value !== null && weChatMsgContainer.value !== null) {
        return wechatMsgListRef.value.scrollTop + weChatMsgContainer.value.scrollHeight >= wechatMsgListRef.value.scrollHeight
    } else {
        return false
    }
}

const loadMsgList = async () => {
    if (shouldUpdate.value && handleScroll()) {
        const projId = projectId.value;
        const uid = targetId.value;
        const wechatId = wechatIdCom.value;
        let target = searchTarget.value

        try {
            const name = selectedSession.value.strUsrName;
            if (props.isGetMsgByTarget === 1) {
                if (searchType.value === '精确') {
                    target = '^' + target + '$'
                }
                await store.dispatch(`weChat/${WeChatActions.asyncGetSearchingMsgByNameAndTarget}`, { projId, uid, wechatId, name, target, isAppend: true });

            } else if (props.isGetMsgByTarget === 2) {
                let userId = selectedSession.value.UserList.UserName
                await store.dispatch(`weChat/${WeChatActions.asyncGetSearchingMsgByNameAndUserId}`, { projId, uid, wechatId, name, userId, isAppend: true });
            }
        } catch (err) {
            console.log(err)
        }
    }
}


const getMsgSender = (msg: WeChatMsg): string => {
    if (msg.IsSender === 1) {
        return "我";
    }
    if (msg.StrTalker.includes("@chatroom")) {
        return msg.senderStr;
    } else {
        return selectedSession.value.strUsrName;
    }
}


watchEffect(async () => {
    if (shouldUpdate.value && msgGroup.value.msgList.length === 0) {
        const projId = projectId.value;
        const uid = targetId.value;
        const wechatId = wechatIdCom.value;
        let target = searchTarget.value

        try {
            const name = selectedSession.value.strUsrName;
            // store.dispatch(`weChat/${WeChatActions.asyncGetMsgListByUidAndName}`, { projId, uid, wechatId, name });
            if (props.isGetMsgByTarget === 1) {
                if (searchType.value === '精确') {
                    target = '^' + target + '$'
                }
                await store.dispatch(`weChat/${WeChatActions.asyncGetSearchingMsgByNameAndTarget}`, { projId, uid, wechatId, name, target, isAppend: false });
            } else if (props.isGetMsgByTarget === 2) {
                let userId = selectedSession.value.UserList.UserName
                await store.dispatch(`weChat/${WeChatActions.asyncGetSearchingMsgByNameAndUserId}`, { projId, uid, wechatId, name, userId, isAppend: false });
            }

            while (handleScroll() && shouldUpdate.value) {
                loadMsgList()
            }

        } catch (err) {
            console.log(err)
        }
    }
});


const highLight = (data: string): highlight[] => {
    const res = []
    if (typeof data === "string") {
        let target: string = searchTarget.value
        const matchedArr = RegExp(target, 'i').exec(data);
        if (!matchedArr || matchedArr.length === 0) {
            res.push({ normal: data, light: '' })
            return res
        }
        const firstMatchedStr = matchedArr[0];
        const temp = data.split(firstMatchedStr)
        const len = temp.length
        for (let i = 0; i < len - 1; i++) {
            res.push({ normal: temp[i], light: firstMatchedStr })
        }
        res.push({ normal: temp[len - 1], light: '' })
        return res
    } else {
        res.push({ normal: data, light: '' })
        return res
    }
}



return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_unref(headerName)), 1)
      ])
    ]),
    _createElementVNode("div", {
      class: "weChatMsgWindowContent",
      ref_key: "weChatMsgContainer",
      ref: weChatMsgContainer
    }, [
      _createElementVNode("div", {
        onScroll: loadMsgList,
        class: "weChatMsgList wechatReverseClass",
        ref_key: "wechatMsgListRef",
        ref: wechatMsgListRef
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(msgGroup).msgList, (msg) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "weChatMsgContent wechatReverseClass",
            key: msg.Sequence
          }, [
            (_openBlock(), _createElementBlock("div", {
              class: "weChatMsg",
              key: msg.Sequence
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("p", null, _toDisplayString(getMsgSender(msg)), 1)
                ]),
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  (msg.Type == 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_el_image, {
                          style: {"width":"70px","height":"70px"},
                          src: _unref(wechatStaticUrl) + msg.StrContent,
                          "preview-src-list": [_unref(wechatStaticUrl) + msg.StrContent],
                          title: "点击查看大图"
                        }, null, 8, ["src", "preview-src-list"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(highLight(msg.StrContent), (i, index) => {
                          return (_openBlock(), _createElementBlock("span", { key: index }, [
                            _createTextVNode(_toDisplayString(i.normal), 1),
                            _createElementVNode("span", _hoisted_10, _toDisplayString(i.light), 1)
                          ]))
                        }), 128))
                      ]))
                ])
              ])
            ]))
          ]))
        }), 128)),
        (_unref(isMsgLoading))
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, "加载中......"))
          : _createCommentVNode("", true),
        (_unref(isCurrentMsgListAllLoaded))
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, "------已加载全部-------"))
          : _createCommentVNode("", true)
      ], 544)
    ], 512)
  ]))
}
}

})